import type { EnvironmentId, ThreadId } from "@cmmd-forge/contracts";

export interface JumpToParentThreadLike {
  readonly environmentId: EnvironmentId;
  readonly kind: "master" | "worker";
  readonly parentThreadId: ThreadId | null;
}

export interface JumpToParentTarget {
  readonly environmentId: EnvironmentId;
  readonly threadId: ThreadId;
}

/**
 * Pure resolver for the `thread.jumpToParent` command.
 *
 * Returns the parent navigation target for a worker thread, or `null` when the
 * command should no-op (no active thread, master thread, or orphan worker with
 * a missing parent id).
 */
export function resolveJumpToParentTarget(
  activeThread: JumpToParentThreadLike | null | undefined,
): JumpToParentTarget | null {
  if (!activeThread) return null;
  if (activeThread.kind !== "worker") return null;
  if (!activeThread.parentThreadId) return null;
  return {
    environmentId: activeThread.environmentId,
    threadId: activeThread.parentThreadId,
  };
}
